import {required, requiredIf} from 'vuelidate/lib/validators'
import { notOlderThanTwoYears, notFutureDate} from "@/validations/date-validation";

const requiredIfDeceased = requiredIf((vm) => {
  return vm.motherCondition === 3;
});

export default {
  dischargeDate: {
    required,
    notFuture: notFutureDate,
    notTooOld: notOlderThanTwoYears,
  },
  motherCondition: {
    required
  },
  antecedentType: {
    requiredIf: requiredIfDeceased
  },
  /*
  antecedentCause: {
    requiredIf: requiredIfDeceased
  },*/
  deathTiming: {
    requiredIf: requiredIfDeceased
  }
}

